.content {
  display: flex;
  align-items: center;
  gap: var(--space-4);
  background: var(--surface-overlay);
  color: var(--text-primary);
  font-size: var(--fs-sm);
  line-height: 1;
  padding: 5px 8px;
  border-radius: var(--radius-sm);
  box-shadow: var(--shadow-menu);
  z-index: 60;
  animation: fadeIn var(--dur-fast) var(--ease);
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
